module.exports = __webpack_public_path__ + "img/background_rutsche_w480.554f2d74.jpg";